import { useState } from 'react';
import { useSnackbars } from '../../../hooks/snackbar.hook';
import { sendPasswordRetrieveRequest } from '../../../services/auth.service';
import { AxiosError } from 'axios';
import { showAxiosMessageError } from '../../../utils/error-message.util';
import ForgetPasswordForms from '../../../components/forms/forgotPassword/forgotPassword.form';
import { useNavigate } from 'react-router-dom';

/**
 * Page d'accueil de l'application
 * @constructor
 */
export default function ForgotPasswordPage() {
    //Navigation
    const navigate = useNavigate();
    //SnackBar pour les messages
    const showMessage = useSnackbars();
    //Use state pour peremttre la saisie du mail pour le mot de passe oublié
    const [validate, setValidate] = useState(false);

    // Comportement au submit du formulaire Login
    const handlerClickSendMail = async (e: { email: string }) => {
        // Empêche de pouvoir submit pendant le traitement
        setValidate(true);
        //Permet d'envoyer un lien pour la réinitialisation de mot de passe
        sendPasswordRetrieveRequest(e.email)
            .then(data => {
                //On précise à l'utilisateur qu'il recevra son lien
                showMessage.successAlert(data.message);
                navigate('/');
            })
            .catch((error: Error | AxiosError) => {
                //En cas d'erreur
                showAxiosMessageError(error, showMessage);
            })
            .finally(() => {
                //Si il y a eu une erreur, l'utilisateur pourra resaisir un mail
                setValidate(false);
            });
    };

    // Comportement au submit du formulaire Login
    const handlerBack = async () => {
        //Retour sur la page home
        navigate('/');
    };

    //Conditionnement de la vue
    //Formulaire envoi de mail pour récupérer mot de passe
    return (
        <ForgetPasswordForms
            handlerBack={handlerBack}
            handlerClickSendMail={handlerClickSendMail}
            validate={validate}
        />
    );
}
